import type { StorageResponsePayload } from "@swiggy-private/native-bridge";
import { deleteFromStorage, getFromStorage, saveToStorage } from "./storage";
import { WebStorageLocation } from "../types";
export const isFrequencyCappedWithTableId = async (
    key: string,
    tableId: string,
    timeOffset: number,
): Promise<boolean> => {
    try {
        const response = await getFromStorage(key);
        const dataStr = response?.data[key];
        const data = JSON.parse(dataStr ?? "{}");
        const frequencyTime = data.value || 0;
        const savedTableId = data.tableId || "";
        if (frequencyTime == null) {
            return await Promise.resolve(false);
        }

        if (Date.now() - Number(frequencyTime) < timeOffset && savedTableId === tableId) {
            return await Promise.resolve(true);
        } else {
            deleteFromStorage(key);
        }

        return await Promise.resolve(false);
    } catch (_) {
        return Promise.resolve(false);
    }
};

export const updateFrequencyCappingWithTableId = async (
    key: string,
    tableId: string,
): Promise<StorageResponsePayload | undefined> => {
    const payload = JSON.stringify({
        tableId,
        value: String(Date.now()),
    });
    const response = await saveToStorage(key, payload);
    return response;
};

export const isFrequencyCappedForCartTooltip = async (key: string) => {
    try {
        const response = await getFromStorage(key, WebStorageLocation.SESSION);
        return response?.data[key] === "true";
    } catch (_) {
        return false;
    }
};

export const updateFrequencyCappingForCartTooltip = async (key: string) => {
    try {
        await saveToStorage(key, "true", WebStorageLocation.SESSION);
    } catch (_) {}
};

export const getCrossSellShownItemIds = async (key: string, parentOrderId: string): Promise<string[]> => {
    if (!parentOrderId) return [];
    try {
        const response = await getFromStorage(key);
        const data = JSON.parse(response?.data[key] ?? "{}");
        if (data.parentOrderId !== parentOrderId) return [];
        return Array.isArray(data.shownItemIds) ? data.shownItemIds : [];
    } catch (_) {
        return [];
    }
};

export const updateCrossSellShownItemIds = async (
    key: string,
    parentOrderId: string,
    shownItemIds: string[],
): Promise<void> => {
    if (!parentOrderId) return;
    await saveToStorage(key, JSON.stringify({ parentOrderId, shownItemIds }));
};
